import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

    }

    init() {

        const splittedTitle = new SplitText(this.el, {type:this.getData('type') !== null ? this.getData('type') : 'words,chars'});

    }

}
